import React, { Component } from 'react';
import {connect} from "react-redux"
import { Checkbox } from 'antd';
import {onCloseStartScreen, onSubmitStateSelection} from "../../Redux/Actions/mapActions";
import {createStructuredSelector} from "reselect";
import {
	initialLoadOfMapHasCompletedSelector,
	selectedUSStatesToFilterWithinSelector,
} from "../../Redux/selectors";
import SubmitUSStatesButton from "../USStatesToFilterWithinMenu/SubmitUSStatesButton";
import {arraysItemsAreShallowlyEqual} from "../../utilsData";

const US_REGIONS = [
	{name:"Northeast", states:["Connecticut", "Maine", "Massachusetts", "New Hampshire", "Rhode Island", "Vermont", "New Jersey", "New York", "Pennsylvania"]},
	{name:"Midwest", states:["Illinois", "Indiana", "Michigan", "Ohio", "Wisconsin", "Iowa", "Kansas", "Minnesota", "Missouri", "Nebraska", "North Dakota", "South Dakota"]},
	{name:"South", states:["Delaware", "Florida", "Georgia", "Maryland", "North Carolina", "South Carolina", "Virginia", "West Virginia", "Alabama", "Kentucky", "Mississippi", "Tennessee", "Arkansas", "Louisiana", "Oklahoma", "Texas"]},
	{name:"West", states:["Arizona", "Colorado", "Idaho", "Montana", "Nevada", "New Mexico", "Utah", "Wyoming", "Alaska", "California", "Hawaii", "Oregon", "Washington"]}
]


const StateCheckboxComponent = React.memo(
	({checked, onChange, usStateName}) => (
		<Checkbox
			onChange={onChange}
			checked={checked}
		>
			<span className="state-name">{usStateName}</span>
		</Checkbox>
	),
	({checked}, nextProps) => checked === nextProps.checked
)

const RegionSectionHeader = React.memo(
	({region, checked, onToggleRegion}) => (
		<div className="region-header">
			<Checkbox onChange={onToggleRegion} checked={checked} />
			<div className="region-title">{region.name}</div>
		</div>
	),
	({checked}, nextProps) => checked === nextProps.checked
)

class USStatesToFilterWithinMenu extends Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedUSStatesToFilterWithinLocalState: props.selectedUSStatesToFilterWithin || []
		}
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		const selectedUSStatesInReduxChanged = !arraysItemsAreShallowlyEqual(this.props.selectedUSStatesToFilterWithin, prevProps.selectedUSStatesToFilterWithin)
		if (selectedUSStatesInReduxChanged) {
			this.setState({
				selectedUSStatesToFilterWithinLocalState: this.props.selectedUSStatesToFilterWithin,
			})
		}
	}
	
	addUSStateToFilterWithinLocally = (usStateNames) => {
		this.setState({
			selectedUSStatesToFilterWithinLocalState: [...usStateNames, ...this.state.selectedUSStatesToFilterWithinLocalState].sort()
		})
	}
	
	removeUSStateToFilterWithinLocally = (usStateNames) => {
		this.setState({
			selectedUSStatesToFilterWithinLocalState: this.state.selectedUSStatesToFilterWithinLocalState.filter(currentUsStateName => !usStateNames.includes(currentUsStateName))
		})
	}
	
	handleChange = (e, usStateName) => {
		if (e.target.checked) {
			this.addUSStateToFilterWithinLocally([usStateName])
		} else {
			this.removeUSStateToFilterWithinLocally([usStateName])
		}
	}
	
	onToggleRegion = (region) => {
		if (this.isRegionSelected(region)) {
			this.removeUSStateToFilterWithinLocally(region.states)
		} else {
			this.addUSStateToFilterWithinLocally(region.states)
		}
	}
	
	isRegionSelected = (region) => {
		const {selectedUSStatesToFilterWithinLocalState} = this.state
		const anyNotSelected = region.states.filter(usStateName => !selectedUSStatesToFilterWithinLocalState.includes(usStateName))
		return anyNotSelected.length === 0
	}
	
	intoColumns = (states) => {
		const {selectedUSStatesToFilterWithinLocalState} = this.state
		const NUM_COLS = 3
		const stateCols = []
		
		let currCols = states.length
		let currMin = 0
		let currMax = undefined
		const isWithinRange = (s, i) => i >= currMin && i < currMax
		for (let i=NUM_COLS; i>0; i--) {
			const offset = Math.ceil(currCols / i)
			currMax = currMin + offset
			const stateCol = states.filter(isWithinRange)
			stateCols.push(stateCol)
			
			currMin = currMax
			currCols -= offset
		}
		
		return (
			<div className='row'>
				{stateCols.map((stateCol, i) => {
					return (
						<div key={i} className='column'>
							{stateCol.map(usStateName => (
									<StateCheckboxComponent
										key={usStateName}
										onChange={e => this.handleChange(e, usStateName)}
										checked={selectedUSStatesToFilterWithinLocalState.includes(usStateName)}
										usStateName={usStateName}
									/>
								)
							)}
						</div>
					)
				})}
			</div>
		)
	}
	
	onSubmit = () => {
		const { selectedUSStatesToFilterWithinLocalState } = this.state
		this.props.onSubmitStateSelection(selectedUSStatesToFilterWithinLocalState)
		this.props.onCloseStartScreen()
	}
	
	render() {
		const { initialLoadOfMapHasCompleted, selectedUSStatesToFilterWithin } = this.props
		const { selectedUSStatesToFilterWithinLocalState } = this.state
		const userHasNotChosenAnyUSStatesYet = selectedUSStatesToFilterWithinLocalState.length === 0
		const localSelectionDiffersFromReduxStateSelection = !arraysItemsAreShallowlyEqual(selectedUSStatesToFilterWithinLocalState, selectedUSStatesToFilterWithin)
		
		return (
			<div>
				<div className='states-checkbox-area'>
					<SubmitUSStatesButton
						onClick={this.onSubmit}
						userHasNotChosenAnyUSStatesYet={userHasNotChosenAnyUSStatesYet}
						localSelectionDiffersFromReduxStateSelection={localSelectionDiffersFromReduxStateSelection}
						initialLoadOfMapHasCompleted={initialLoadOfMapHasCompleted}
					/>
					{US_REGIONS.map((region, idx) => (
						<div key={idx} className="region-selector-section">
							<RegionSectionHeader
								region={region}
								onToggleRegion={() => this.onToggleRegion(region)}
								checked={this.isRegionSelected(region)}
							/>
							<div>
								{this.intoColumns(region.states.sort())}
							</div>
						</div>
					))}
				</div>
			</div>
		)
	}
}


// Redux

const mapStateToProps = createStructuredSelector({
	selectedUSStatesToFilterWithin: selectedUSStatesToFilterWithinSelector,
	initialLoadOfMapHasCompleted: initialLoadOfMapHasCompletedSelector,
})

const mapDispatchToProps = {
	onCloseStartScreen,
	onSubmitStateSelection,
}

export default connect(mapStateToProps, mapDispatchToProps)(USStatesToFilterWithinMenu);
